
import React from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup';
import { Button, FormGroup, Label } from 'reactstrap';
const formSchema = Yup.object().shape({
    password: Yup.string()
      .required('Password is mendatory'),
    confirmPwd: Yup.string()
      .required('Password is mendatory')
      .oneOf([Yup.ref('password')], 'Passwords does not match'),
  })
const ResetPwdForm=({loading, onSubmit, onCancelClick})=>{
    const formOptions = { resolver: yupResolver(formSchema) }
    const { register, handleSubmit, reset, formState } = useForm(formOptions)
    const { errors } = formState
    const onFormSubmit=(data)=> {
        console.log(JSON.stringify(data, null, 4))
        onSubmit(data);
        return false
      }
    return (<>
        <form onSubmit={handleSubmit(onFormSubmit)}>
            <FormGroup>
                <Label>New Password</Label>
                <input
                    name="password"
                    type="password"
                    {...register('password')}
                    className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                />
                <div className="invalid-feedback">{errors.password?.message}</div>
            </FormGroup>
            <FormGroup>
                <Label>Confirm Password</Label>
                <input
                    name="confirmPwd"
                    type="password"
                    {...register('confirmPwd')}
                    className={`form-control ${errors.confirmPwd ? 'is-invalid' : ''}`}
                />
                <div className="invalid-feedback">{errors.confirmPwd?.message}</div>
            </FormGroup>
            <FormGroup>          
                <Button color="primary" block className="mt-3" 
                    disabled={loading}
                    >{
                        loading?<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading</>:'Submit'
                    }
                </Button>
            </FormGroup>
            <FormGroup>
                <Button color="primary" block className="mt-3" type="button" onClick={(e)=>{onCancelClick(e);}}>Cancel</Button>
            </FormGroup>
      </form> </>)
}
export default ResetPwdForm